module.exports = __webpack_public_path__ + "media/images/video-play-9b737958.svg";